import { createSelector, createEntityAdapter } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';

const trailAdapter = createEntityAdapter({
  selectId: (e) => e.trail_id,
});

const initialState = trailAdapter.getInitialState();

export const trailApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTrail: builder.query({
      query: (trailId) => ({
        url: `/trail?id=${encodeURIComponent(trailId)}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getTrailList: builder.query({
      query: () => ({
        url: `/trail/list`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getTrailListByQRCode: builder.query({
      // By the permanent code printed on the sign, e.g. CMT-DL7R.
      query: (qrCode) => ({
        url: `/trail/list-by-qrcode?code=${encodeURIComponent(qrCode)}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getTrailCheckin: builder.query({
      query: (trailCheckinId) => ({
        url: `/trail/checkin?id=${encodeURIComponent(trailCheckinId)}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getTrailWeather: builder.query({
      query: (trailId) => ({
        url: `/trail/weather?id=${encodeURIComponent(trailId)}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
  }),
});

export const {
  useGetTrailQuery,
  useGetTrailListQuery,
  useGetTrailListByQRCodeQuery,
  useGetTrailCheckinQuery,
  useGetTrailWeatherQuery,
} = trailApiSlice;
